const formatter = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export function formatBRL(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return formatter.format(0);
  return formatter.format(n);
}

export function parseCurrencyInput(text) {
  const cleaned = String(text).replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
  const n = parseFloat(cleaned);
  return Number.isNaN(n) ? 0 : n;
}
